import { render, staticRenderFns } from "./OptionalProductGroup.vue?vue&type=template&id=71dc0fdd&scoped=true&"
import script from "./OptionalProductGroup.vue?vue&type=script&lang=ts&"
export * from "./OptionalProductGroup.vue?vue&type=script&lang=ts&"
import style0 from "./OptionalProductGroup.vue?vue&type=style&index=0&id=71dc0fdd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71dc0fdd",
  null
  
)

export default component.exports